module.exports = "/_next/static/images/offers1-2x-91a1f5c5e951c6bab9b22228bf5d7af7.jpg.webp";